import { ReactComponent as HtmlIcon } from '../components/Resume/icons/html5Icon.svg';
import { ReactComponent as CssIcon } from '../components/Resume/icons/css3Icon.svg';
import { ReactComponent as JsIcon } from '../components/Resume/icons/javascriptIcon.svg';
import { ReactComponent as ReactIcon } from '../components/Resume/icons/reactIcon.svg';
import { ReactComponent as ReduxIcon } from '../components/Resume/icons/reduxIcon.svg';
import { ReactComponent as JqueryIcon } from '../components/Resume/icons/jqueryIcon.svg';
import { ReactComponent as TsIcon } from '../components/Resume/icons/typescriptIcon.svg';
import { ReactComponent as MaterialUiIcon } from '../components/Resume/icons/materialIcon.svg';
import { ReactComponent as BootstrapIcon } from '../components/Resume/icons/bootstrapIcon.svg';
import { ReactComponent as GitHubIcon } from '../components/Resume/icons/githubIcon.svg';
import { ReactComponent as TailwindIcon } from '../components/Resume/icons/tailwind.svg';
import { ReactComponent as ReactHookFormIcon } from '../components/Resume/icons/reactHookFormIcon.svg';
import { ReactComponent as YupIcon } from '../components/Resume/icons/yupIcon.svg';
import { ReactComponent as FirebaseIcon } from '../components/Resume/icons/firebaseIcon.svg';
import { ReactComponent as NextIcon } from '../components/Resume/icons/nextIcon.svg';
import { ReactComponent as ZustandIcon } from '../components/Resume/icons/zustandIcon.svg';
import { ReactComponent as FormikIcon } from '../components/Resume/icons/formikIcon.svg';
// import { ReactComponent as NodeJsIcon } from "../components/Resume/icons/nodeIcon.svg";
import { ReactComponent as FigmaIcon } from '../components/Resume/icons/figmaIcon.svg';
import { ReactComponent as PhotoShopIcon } from '../components/Resume/icons/photoshopIcon.svg';
import styles from '../components/Resume/Resume.module.css';

export const resumeTitle = (
    <>
        <span>Re</span>sume
    </>
);
export const resumeTitleUA = (
    <>
        <span>Ре</span>зюме
    </>
);

export const resumeSubTitle = (
    <>
        <span>My</span> skills
    </>
);
export const resumeSubTitleUA = (
    <>
        <span>Мої</span> навики
    </>
);

export const resumeExperience = 'Experience';
export const resumeExperienceUA = 'Досвід';

export const resumeEducation = 'Education';
export const resumeEducationUA = 'Освіта';

export const resumeCoding = 'Stack';
export const resumeCodingUA = 'Стек';

export const resumeLanguages = 'Languages';
export const resumeLanguagesUA = 'Мови';

export const resumeKnowledge = 'Knowledge';
export const resumeKnowledgeUA = 'Знання';

export const knowledge = [
    'Website hosting',
    'HTML adaptive page layout based on design templates',
    'Working with CSS animations',
    'Working in the Figma online graphic editor',
];
export const knowledgeUA = [
    'Хостинг веб-сайту',
    'Адаптивна верстка сторінки на основі дизайн-шаблонів',
    'Робота з CSS анімаціями',
    'Робота в онлайн графічному редакторі Figma',
];

export const stack = [
    {
        title: 'CSS',
        icon: <CssIcon className={styles.icons} />,
        sortNumber: 2,
    },
    {
        title: 'HTML',
        icon: <HtmlIcon className={styles.icons} />,
        sortNumber: 1,
    },
    {
        title: 'JavaScript',
        icon: <JsIcon className={styles.icons} />,
        sortNumber: 3,
    },
    {
        title: 'React.js',
        icon: <ReactIcon className={styles.icons} />,
        sortNumber: 4,
    },
    {
        title: 'TypeScript',
        icon: <TsIcon className={styles.icons} />,
        sortNumber: 5,
    },
    {
        title: 'Redux',
        icon: <ReduxIcon className={styles.icons} />,
        sortNumber: 6,
    },
    {
        title: 'jQuery',
        icon: <JqueryIcon className={styles.icons} />,
        sortNumber: 8,
    },
    {
        title: 'Material UI',
        icon: <MaterialUiIcon className={styles.icons} />,
        sortNumber: 12,
    },
    {
        title: 'Bootstrap',
        icon: <BootstrapIcon className={styles.icons} />,
        sortNumber: 13,
    },
    {
        title: 'Tailwind CSS',
        icon: <TailwindIcon className={styles.icons} />,
        sortNumber: 14,
    },
    {
        title: 'RHF',
        icon: <ReactHookFormIcon className={styles.icons} />,
        sortNumber: 10,
    },
    {
        title: 'Yup',
        icon: <YupIcon className={styles.icons} />,
        sortNumber: 11,
    },
    {
        title: 'Firebase',
        icon: <FirebaseIcon className={styles.icons} />,
        sortNumber: 9,
    },
    {
        title: 'GitHub',
        icon: <GitHubIcon className={styles.icons} />,
        sortNumber: 15,
    },
    // {
    //     title: "NODE.js",
    //     icon: <NodeJsIcon className={styles.icons} />,
    //     sortNumber: 7,
    // },
    {
        title: 'Next.js',
        icon: <NextIcon className={styles.icons} />,
        sortNumber: 7,
    },
    {
        title: 'Figma',
        icon: <FigmaIcon className={styles.icons} />,
        sortNumber: 16,
    },
    {
        title: 'PhotoShop',
        icon: <PhotoShopIcon className={styles.icons} />,
        sortNumber: 17,
    },
    {
        title: 'Zustand',
        icon: <ZustandIcon className={styles.icons} />,
        sortNumber: 18,
    },
    {
        title: 'Formik',
        icon: <FormikIcon className={styles.icons} />,
        sortNumber: 19,
    },
    {
        title: 'React Native',
        icon: <ReactIcon className={styles.icons} />,
        sortNumber: 20,
    },
];
